import { GPI } from "components/Onboarding/GPI/GPI";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding/gpi")({
    component: GPI,
});
